module.exports = __webpack_public_path__ + "img/password.4761b836.svg";